<template>
  <div :id="this.id" class="map-height"></div>
</template>

<script>
// 引入基本模板
let echarts = require("echarts/lib/echarts");
let dawanqu = require("../../static/guangdong.json");
export default {
  name: "",
  data() {
    return {};
  },
  props: {
    id: Number,
    // color: String,
    detaildata: Array,
    xAxisdata: Array,
    title: String,
    color: String
  },
  mounted() {
    // console.log(this.detaildata,this.xAxisdata);
    this.drawLine(this.id, this.detaildata);
    this.chartAuto();
    console.log(dawanqu);
  },
  watch: {
    detaildata: {
      handler(newQuestion, oldQuestion) {
        this.$nextTick(() => {
          this.drawLine(this.id, newQuestion);
        });
      },
      deep: true
    },
    xAxisdata: {
      handler(newQuestion, oldQuestion) {
        this.$nextTick(() => {
          this.xAxisdata = newQuestion;
        });
      },
      deep: true
    }
  },
  methods: {
    drawLine(id, bardata) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById(id));
      echarts.registerMap("guangdong", dawanqu);
      var geoCoordMap = {
        珠海市: [113.353986, 22.124979],
        广州市: [113.420637, 23.125178],
        中山市: [113.382391, 22.521113],
        佛山市: [112.982717, 23.028762],
        江门市: [112.794942, 22.290431],
        肇庆市: [112.472529, 23.051546],
        东莞市: [113.846262, 22.946237],
        惠州市: [114.412599, 23.079404],
        深圳市: [114.085947, 22.607]
      };
      var data = [
        {
          name: "珠海市",
          value: 10
        },
        {
          name: "广州市",
          value: 20
        },
        {
          name: "中山市",
          value: 30
        },
        {
          name: "佛山市",
          value: 40
        },
        {
          name: "江门市",
          value: 50
        },
        {
          name: "肇庆市",
          value: 60
        },
        {
          name: "东莞市",
          value: 70
        },
        {
          name: "惠州市",
          value: 80
        },
        {
          name: "深圳市",
          value: 50
        }
      ];
      var convertData = function(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var geoCoord = geoCoordMap[data[i].name];
          if (geoCoord && geoCoord!='深圳市') {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value)
            });
          }
        }
        return res;
      };
      var convertData1 = function(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var geoCoord = geoCoordMap[data[i].name];
          if (geoCoord && geoCoord == '深圳市') {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value)
            });
          }
        }
        return res;
      };
      let linedata = [];
      var res = [
        [
          [114.085947, 22.607],
          [113.353986, 22.124979]
        ],
        [
          [114.085947, 22.607],
          [113.420637, 23.125178]
        ],
        [
          [114.085947, 22.607],
          [113.382391, 22.521113]
        ],
        [
          [114.085947, 22.607],
          [112.982717, 23.028762]
        ],
        [
          [114.085947, 22.607],
          [112.794942, 22.290431]
        ],
        [
          [114.085947, 22.607],
          [112.472529, 23.051546]
        ],
        [
          [114.085947, 22.607],
          [113.846262, 22.946237]
        ],
        [
          [114.085947, 22.607],
          [114.412599, 23.079404]
        ]
      ];
      res.forEach(function(item) {
        linedata.push({
          coords: item
        });
      });

      // 绘制图表
      let option = {
        title: {
          text: "深企流出图",
          textStyle:{
            color: '#2c3e5c'
          },
          top:30,
          x: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          x: "left",
          data: ["iphoneX"]
        },
        // dataRange: {
        //   min: 0,
        //   max: 2500,
        //   x: "left",
        //   y: "bottom",
        //   text: ["max", "min"],
        //   calculable: true
        // },
        visualMap: {
          //颜色的设置  dataRange
          show: false,
          x: "left",
          y: "center",
          // seriesIndex: [1],
          min: 0,
          max: 100,
          text: ["高", "低"], // 文本，默认为数值文本
          textStyle: {
            color: "#fff"
          },
          inRange: {
            color: [
              "#f4eced",
              "#d9d5ff",
              "#f3d4ff",
              "#d6eef8",
              "#f5eec4",
              "#b3e4ff",
              "#d3f8dd",
              "#faaeb2",
              "#f7dfd7"
            ]
          }
        },
        geo: {
          map: "guangdong",
          zoom: 1.26,
          itemStyle: {
            //地图区域的多边形 图形样式
            color: "#fff",
            normal: {
              //是图形在默认状态下的样式
              label: {
                show: true, //是否显示标签
                textStyle: {
                  color: "#ff0"
                }
              },

              borderWidth: 1,
              borderColor: "#0692fc",
              shadowColor: "#e8e8e8",
              shadowOffsetY: 15,
              shadowOffsetX: 8
            }
          }
        },
        series: [
          {
            name: "",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: convertData(data),
            symbolSize: function(val) {
              return val[2] / 5;
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke"
            },
            hoverAnimation: true,
            label: {
              normal: {
                formatter: "{b}",
                position: "bottom",
                color: "#fff",
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: "#0caffa",
                shadowBlur: 0,
                shadowColor: "#0caffa"
              }
            },
            zlevel: 1
          },
          {
            name: "",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: convertData1(data),
            symbolSize: function(val) {
              return val[2] / 5;
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke"
            },
            hoverAnimation: true,
            label: {
              normal: {
                formatter: "{b}",
                position: "bottom",
                color: "#fff",
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: "#fb0205",
                shadowBlur: 0,
                shadowColor: "#fb0205"
              }
            },
            zlevel: 1
          },
          {
            type: "map",
            mapType: "guangdong",
            zoom: 1.26,
            roam: false, //是否开启鼠标缩放和平移漫游
            itemStyle: {
              //地图区域的多边形 图形样式
              // color: ['rgb(11,85,142)', 'rgb(13,106,177)'],
              normal: {
                //是图形在默认状态下的样式
                label: {
                  show: true, //是否显示标签
                  textStyle: {
                    color: "transparent"
                  }
                },
                borderWidth: 1,
                borderColor: "#28729f",
                areaColor: "#29b4b7"
              },
              emphasis: {
                //是图形在高亮状态下的样式,比如在鼠标悬浮或者图例联动高亮时
                label: {
                  show: false,
                  textStyle: {
                    color: "transparent"
                  }
                },
                borderColor: "#28729f",
                areaColor: "#9ea9f7"
              }
            },

            data: data
          },
          {
            name: "lines",
            type: "lines",
            coordinateSystem: "geo",
            effect: {
              constantSpeed: 30,
              show: true,
              trailLength: 0.7,
              symbolSize: 3,
              color: "rgba(255, 255, 255, 0.5)",
              symbol: "circle"
            },

            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#0caffa",
                  width: 0.8,
                  opacity: 0.9,
                  curveness: 0.2
                }
              }
            },
            data: linedata
          }
        ]
      };

      myChart.setOption(option);
    },
    chartAuto() {
      let myChart = this.$echarts.init(document.getElementById(this.id));
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/common/gbamap.vue